const message_ref = (state = 0, action) => {
	switch (action.type) {
		case "SET_REF":
			return action.ref;
		default:
			return state;
	}
};
export default message_ref;
